import { render, staticRenderFns } from "./wordShorthand.vue?vue&type=template&id=4d29ced9&scoped=true&"
import script from "./wordShorthand.vue?vue&type=script&lang=js&"
export * from "./wordShorthand.vue?vue&type=script&lang=js&"
import style0 from "./wordShorthand.vue?vue&type=style&index=0&id=4d29ced9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29ced9",
  null
  
)

export default component.exports